// export const API_URL = "https://dev.sevenairaviation.com";
export const API_URL = "https://sevenairaviation.com";

// export const GOOGLE_MAP_API_KEY = "AIzaSyANFvytlUdoF9WVD7zmQm5N9UhTF2FSjjc";
